import React from 'react';
import CoursePageTemplate from './components/CoursePageTemplate';

function ZeroProfessor() {
  return (
    <CoursePageTemplate
      courseId="zero-professor"
      backgroundColor="linear-gradient(135deg, #3a0066 0%, #5c00a3 100%)"
    />
  );
}

export default ZeroProfessor;
